import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]
  static classes = ["hidden"]

  toggle() {
    this.contentTarget.classList.toggle(this.hiddenClass)

    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-90")
    }
  }
}
